/**
 * Product Configurator Constants
 */

// Modal content
export const PRODUCTS_DELETE_MODAL_CONTENT =
  "Are you sure you want to delete this product? This action cannot be undone.";
export const CANCEL_MODAL_CONFIRMATION_CONTENT =
  "You have unsaved changes. Are you sure you want to cancel?";

// Common constants
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_STARTING_PAGE = 1;

// Product status codes
export const PRODUCT_STATUS_ACTIVE = 1;
export const PRODUCT_STATUS_INACTIVE = 0;

// Storage keys
export const PRODUCT_STORAGE_KEY = "products";
export const CATEGORY_STORAGE_KEY = "categories";
export const CONFIG_OPTION_STORAGE_KEY = "configOptions";

// Option unit options — values match Dataverse choice field
export const OPTION_UNIT_OPTIONS = [
  { value: 1, label: "Per Window" },
  { value: 2, label: "Per Sash" },
  { value: 3, label: "Per Meter" },
  { value: 4, label: "Per Unit" },
  { value: 5, label: "Per Frame" },
];

export const DEFAULT_OPTION_UNIT = 1;

// Category type options
export const CATEGORY_TYPE_OPTIONS = [
  { value: 1, label: "Window Type" },
  { value: 2, label: "Measurements" },
  { value: 3, label: "Sash" },
  { value: 12, label: "Profile Colours" },
  { value: 4, label: "Cill" },
  { value: 5, label: "Hardware" },
  { value: 6, label: "Security" },
  { value: 7, label: "Decorative Bars" },
  { value: 8, label: "Trickle Vents" },
  { value: 9, label: "Glazing" },
  { value: 10, label: "Add Ons" },
  { value: 11, label: "Optional Extras" },
];

// Product structure types
export interface IProductStructureOption {
  label: string;
  value: number;
}

export const PRODUCT_STRUCTURE_TYPES: IProductStructureOption[] = [
  { label: "Standard", value: 1 },
  { label: "Arch", value: 2 },
  { label: "Bays", value: 3 },
  { label: "Coupled", value: 4 },
];

// Export query keys
export * from "./queryKey";

// Export option types
export * from "./optionTypes";

// Export input types
export * from "./inputTypes";
